import { render, staticRenderFns } from "./mulitActivityModal.vue?vue&type=template&id=72f0113d&scoped=true"
import script from "./mulitActivityModal.vue?vue&type=script&lang=js"
export * from "./mulitActivityModal.vue?vue&type=script&lang=js"
import style0 from "./mulitActivityModal.vue?vue&type=style&index=0&id=72f0113d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f0113d",
  null
  
)

export default component.exports